import {createWebHistory, createRouter} from "vue-router";

import Dashboard from "@/components/views/Dashboard.vue";
import Copyright from "@/components/views/Copyright.vue";
import TermsOfService from "@/components/views/TermsOfService.vue";
import PrivacyStatement from "@/components/views/PrivacyStatement.vue";
import Beta from "@/components/views/Beta.vue";
import Contact from "@/components/views/Contact.vue";

import SignIn from "@/components/users/SignIn";
import SignUp from "@/components/users/SignUp";

import ResetPassword from "@/components/users/ResetPassword";
import ResetPasswordRequest from "@/components/users/ResetPasswordRequest";

import UserSettings from "@/components/users/UserSettings";
import SelectUser from "@/components/users/SelectUser";

import TournamentsDashboard from "@/components/tournaments/TournamentsDashboard";
import Tournament from "@/components/tournaments/Tournament";
import EditTournament from "@/components/tournaments/EditTournamentDetails";
import RoundDetails from "@/components/tournaments/rounds/RoundDetails"

import ClubsDashboard from "@/components/clubs/ClubsDashboard";
import ClubDetails from "@/components/clubs/ClubDetails";

import PersonsDashboard from "@/components/players/PersonsDashboard";
import Person from "@/components/players/Person";

import Modal from "@/components/Modal";
import ManagementDashboard from "@/components/management/ManagementDashboard"
import msalSignIn from "@/components/users/MSALSignin"

import EmailConfirmation from "@/components/users/EmailConfirmation";
import EmailConfirmResend from "@/components/users/EmailConfirmationResend";

import InfoLinkingAccount from "@/components/views/info/LinkingAccount";
import About from "@/components/views/info/About";
import Version from "@/components/views/info/Version";

import Donate from "@/components/views/Donate";

const routes = [
    {
        path: "/",
        name: "Dashboard",
        component: Dashboard,
    },
    {
        path: "/management",
        name: "ManagementDashboard",
        component: ManagementDashboard,
    },
    {
        path: "/sign-in",
        name: "SignIn",
        component: SignIn,
    },
    {
        path: "/msal",
        name: "msal",
        component: msalSignIn,
    },
    {
        path: "/sign-up",
        name: "SignUp",
        component: SignUp,
    },
    {
        path: "/user-settings",
        name: "UserSettings",
        component: UserSettings,
    },
    {
        path: "/reset-password-request",
        name: "ResetPasswordRequest",
        component: ResetPasswordRequest,
    },
    {
        path: "/password-reset",
        name: "ResetPassword",
        component: ResetPassword,
    },
    {
        path: "/round-details/:roundId",
        name: "RoundDetails",
        component: RoundDetails,
    },
    {
        path: "/tournaments",
        name: "TournamentsDashboard",
        component: TournamentsDashboard,
    },
    {
        path: "/tournaments/:tournamentId",
        name: "Tournament",
        component: Tournament,
    },
    {
        path: "/tournaments/edit/:tournamentId",
        name: "EditTournamentDetails",
        component: EditTournament,
    },
    {
        path: "/clubs",
        name: "ClubsDashboard",
        component: ClubsDashboard,
    },
    {
        path: "/clubs/:clubId",
        name: "ClubDetails",
        component: ClubDetails,
    },
    {
        path: "/persons",
        name: "PersonsDashboard",
        component: PersonsDashboard,
    },
    {
        path: "/persons/:personId",
        name: "Person",
        component: Person,
    },
    {
        path: "/beta/",
        name: "Beta",
        component: Beta,
    },
    {
        path: "/copyright/",
        name: "Copyright",
        component: Copyright,
    },
    {
        path: "/terms-of-service/",
        name: "TermsOfService",
        component: TermsOfService,
    },
    {
        path: "/privacy-statement/",
        name: "PrivacyStatement",
        component: PrivacyStatement,
    },
    {
        path: "/contact/",
        name: "Contact",
        component: Contact,
    },
    {
        path: "/select-user/",
        name: "SelectUser",
        component: SelectUser,
    },
    {
        path: "/modal/",
        name: "Modal",
        component: Modal,
    },
    {
        path: "/email-confirmation/",
        name: "EmailConfirmation",
        component: EmailConfirmation,
    },
    {
        path: "/resend-confirmation/",
        name: "EmailConfirmResend",
        component: EmailConfirmResend,
    },
    {
        path: "/info/linking-account/",
        name: "InfoLinkingAccount",
        component: InfoLinkingAccount,
    },
    {
        path: "/info/about/",
        name: "About",
        component: About,
    },
    {
        path: "/info/version/",
        name: "Version",
        component: Version,
    },
    {
        path: "/donate/",
        name: "Donate",
        component: Donate,
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
